@if (showShell) {
  <div class="app-shell">
    <app-navbar
      [currentDate]="currentDate"
      [activeTheme]="activeTheme"
      [userName]="userName"
      [userRole]="userRole"
      (menuToggle)="toggleMenu()"
      (themeChange)="onThemeChange($event)"
      (profileClick)="navigateToProfile()"
      (settingsClick)="navigateToSettings()"
      (logout)="logout()"
    ></app-navbar>

    <div class="layout">
      <app-sidebar [sections]="sections" [menuOpen]="menuOpen" (closeMenu)="closeMenu()"></app-sidebar>

      <main class="content">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
